import styles from './index.module.scss'
import finishSvg from '@/assets/images/card-task-finish.png'
import loadingSvg from '@/assets/images/card-task-loading.svg'
import cn from 'classnames'
import LottieLoading from '@/components/lottie-loading'
import failedSvg from '@/assets/images/tab-icon-failed.svg'
interface TextCardProps {
  title?: string
  text?: string
  status: number
}

const TextCard = (props: TextCardProps) => {
  const { title, status = 1 } = props

  const statusMap = {
    0: loadingSvg,
    1: loadingSvg,
    2: finishSvg,
    3: failedSvg
  }

  // status 为 0 或 1 时显示 loading 动画
  const isLoading = status === 1

  return (
    <div
      className={cn({
        [styles.loadingContainer]: isLoading,
        [styles.container]: !isLoading
      })}
    >
      <div className={styles.header}>
        {isLoading ? (
          <div className={styles.icon}>
            <LottieLoading />
          </div>
        ) : (
          <img
            className={cn(styles.icon, {
              [styles.loading]: isLoading
            })}
            src={statusMap[status]}
            alt="icon"
          />
        )}
        <span className={styles.title}>{title}</span>
      </div>
    </div>
  )
}

export default TextCard
